import hydrate from '../lib/hydrate';
import MobileSignInMenu from '../lib/components/SignIn/MobileSignInMenu';
import { MOBILE_SIGN_IN_MENU_FRONTEND } from '../lib/tools/constants';

hydrate({
  frontend: MOBILE_SIGN_IN_MENU_FRONTEND,
  component: MobileSignInMenu,
});
